import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FormattedMessage, defineMessages, injectIntl,
} from 'react-intl';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { AssessmentConstants } from '../../shared/Constants';
import DownloadReportButton from '../button/DownloadReportButton';
import { intlShape } from '../prop-types';
import { withAccount } from '../AccountContext';

const i18n = defineMessages({
  INDIVIDUAL: {
    id: 'report.individual',
    defaultMessage: 'Individual Report',
  },
  CC_INTERESTS: {
    id: 'report.CC.interests',
    defaultMessage: 'Career Counseling - Interests',
  },
  CC_PERSONALITY: {
    id: 'report.CC.personality',
    defaultMessage: 'Career Counseling - Personality',
  },
});

const REPORTS_WITHOUT_JOB_PROFILE = ['INDIVIDUAL', 'CC_INTERESTS', 'CC_PERSONALITY'];

class BoxActionSubmitted extends Component {
  constructor(props) {
    super(props);

    const printerFriendlyReportSetting = { 'prefer-printer-friendly-reports': false };

    this.state = {
      downloadReportLocale: 'en',
      downloadReportType: 'INDIVIDUAL',
      RespondentPrinter: !printerFriendlyReportSetting['prefer-printer-friendly-reports'],
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateLocale = this.updateLocale.bind(this);
    this.ChangeRespondentPrinterFiendly = this.ChangeRespondentPrinterFiendly.bind(this);
  }

  handleInputChange(event) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;

    this.setState({ [name]: value });
  }

  updateLocale(locale) {
    this.setState({ downloadReportLocale: locale });
  }

  ChangeRespondentPrinterFiendly(event) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({ RespondentPrinter: value });
  }

  render() {
    const {
      assessment,
      availableTranslations,
      intl: { formatMessage },
      currentAccount,
    } = this.props;
    const { instrument } = assessment;
    const { downloadReportLocale, RespondentPrinter, downloadReportType = '' } = this.state;
    const assessmentId = assessment.id;
    const reportParams = {
      locale: downloadReportLocale,
      printerFriendly: RespondentPrinter,
      assessment: assessmentId,
      account: currentAccount,
    };
    const reportTypes = REPORTS_WITHOUT_JOB_PROFILE.map(type => ({
      value: type,
      label: formatMessage(i18n[type]),
    }));
    return (
      instrument === AssessmentConstants.INSTRUMENT_TYPES.STD && (
        <div className="vertList-item vertList-item--block">
          <div className="p-grid p-fluid">
            <div className="p-col p-md-6 p-sm-12">
              <div className="form-group">
                <FormattedMessage id="report" defaultMessage="REPORT">
                  {text => (
                    <label htmlFor="report-type" className="field-label">
                      {text}
                    </label>
                  )}
                </FormattedMessage>
                <Dropdown
                  name="downloadReportType"
                  options={reportTypes}
                  onChange={this.handleInputChange}
                  onBlur={this.handleInputChange}
                  value={downloadReportType}
                  filter
                />
              </div>
            </div>
            <div className="p-col p-md-6 p-sm-12">
              <div className="form-group">
                <FormattedMessage id="attrs.locale" defaultMessage="Preferred Language">
                  {text => (
                    <label htmlFor="report-language" className="field-label">
                      {text}
                    </label>
                  )}
                </FormattedMessage>
                <Dropdown
                  name="downloadReportLocale"
                  options={availableTranslations}
                  onChange={value => this.updateLocale(value.value)}
                  value={downloadReportLocale}
                  filter
                />
              </div>
            </div>
          </div>
          <div className="p-grid">
            <div className="p-col-12">
              <Checkbox
                inputId="respondentPfReports"
                name="respondent-printer-friendly-reports"
                onChange={this.ChangeRespondentPrinterFiendly}
                checked={RespondentPrinter}
              />
              <FormattedMessage
                id="preferences.prefer-printer-friendly-reports"
                defaultMessage="I prefer printer friendly reports"
              >
                {text => (
                  <label htmlFor="respondentPfReports" className="p-checkbox-label">
                    {text}
                  </label>
                )}
              </FormattedMessage>
            </div>
          </div>
          <div>
            {downloadReportType === 'INDIVIDUAL' && (
              <DownloadReportButton
                buttonClass=""
                reportParams={reportParams}
                typeButton="generate"
                additionalClass="clearfix text-center"
                type={downloadReportType}
                isDisabled={false}
                reportFormId={assessmentId}
              />
            )}
            {downloadReportType === 'CC_INTERESTS' && (
              <DownloadReportButton
                buttonClass=""
                reportParams={reportParams}
                typeButton="generate"
                additionalClass="clearfix text-center"
                type={downloadReportType}
                isDisabled={false}
                reportFormId={assessmentId}
              />
            )}
            {downloadReportType === 'CC_PERSONALITY' && (
              <DownloadReportButton
                buttonClass=""
                reportParams={reportParams}
                typeButton="generate"
                additionalClass="clearfix text-center"
                type={downloadReportType}
                isDisabled={false}
                reportFormId={assessmentId}
              />
            )}
          </div>
        </div>
      )
    );
  }
}

BoxActionSubmitted.propTypes = {
  assessment: PropTypes.objectOf(PropTypes.any).isRequired,
  availableTranslations: PropTypes.arrayOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
  currentAccount: PropTypes.string.isRequired,
};

export default withAccount(
  injectIntl(BoxActionSubmitted),
);
